import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import { showError, showSuccess } from "../../helpers/Toast";
import { Header } from "../../components";
import { createDinas } from "../../helpers/ApiPresensi";
import { decryptLocalStorage } from "../../helpers/SecureStorage";

const UploadDinas = () => {
  const navigate = useNavigate();
  const data = useLocation();
  const shiftpresensi = data.state?.shift;
  const [shift, setshift] = useState([]);
  const [keterangan, setketerangan] = useState("");
  const defaultOption = shift[0];
  const [tgl, settgl] = useState(new Date());
  const [file, setFile] = useState();
  const [shift_id, setshift_id] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = decryptLocalStorage(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("presensiId", shift_id === "" ? shift[0]?.id : shift_id);
    body.append("tanggal", moment(tgl).format("YYYY-MM-DD"));
    body.append("keterangan", keterangan);
    body.append("fileBukti", file);

    try {
      setIsSubmitting(true);
      const response = await fetch(createDinas, {
        method: "POST",
        mode: "cors",
        headers: { Authorization: `Bearer ${token}` },
        body: body,
      });

      if (!response.ok) {
        const errorData = await response.json();
        showError(JSON.stringify(errorData.message).replace(/["{}]/g, "").replace(/:/, ": "));
        return;
      }
      showSuccess("Dinas berhasil diajukan");
      navigate("/home");
    } catch (error) {
      showError("Dinas gagal diajukan");
    } finally {
      setIsSubmitting(false);
    }
  };

  function handleChange(event) {
    setFile(event.target.files[0]);
  }

  const getshift = async () => {
    if (shiftpresensi) {
      const shiftData = shiftpresensi.map((item) => ({
        id: item.id_presensi,
        label: item.label,
        value: item.label,
      }));
      setshift(shiftData);
    }
  };

  const onselectstatus = (data) => {
    const objek = shift.find((item) => item.value === data.value);
    setshift_id(objek?.id || "");
  };

  useEffect(() => {
    getshift();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Helmet>
        <title>Upload Dinas</title>
      </Helmet>

      <div
        className="w-full px-4 pt-6 pb-14"
        style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
      >
        <Header to="/home" title="Upload Dinas" />
      </div>

      <div className="flex-grow px-4 pb-6" style={{ marginTop: -40 }}>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-4 space-y-4">
            {/* Shift */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Shift</label>
              <Dropdown
                options={shift}
                onChange={onselectstatus}
                value={defaultOption}
                placeholder="Pilih Shift"
              />
            </div>

            {/* Tanggal */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Tanggal</label>
              <DatePicker
                className="w-full text-sm text-gray-700 bg-gray-50 rounded-xl px-3 py-2.5 border border-gray-200 focus:outline-none"
                selected={tgl}
                onChange={(date) => settgl(date)}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            {/* Keterangan */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Keterangan</label>
              <textarea
                value={keterangan}
                onChange={(e) => setketerangan(e.target.value)}
                placeholder="Masukkan keterangan dinas"
                rows={3}
                className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 focus:border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400/30 resize-none"
              />
            </div>

            {/* Bukti */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Bukti Dinas</label>
              <div className="border-2 border-dashed border-gray-200 rounded-xl p-4 text-center bg-gray-50">
                <input type="file" onChange={handleChange} className="w-full text-sm text-gray-500" />
                <p className="text-xs text-gray-400 mt-1">PDF, JPG, PNG (maks 5MB)</p>
              </div>
            </div>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full flex items-center justify-center gap-2 rounded-2xl py-3.5 text-sm font-bold text-white shadow-md transition active:scale-95 disabled:opacity-70"
            style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
          >
            {isSubmitting ? (
              <>
                <svg className="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                </svg>
                Menyimpan...
              </>
            ) : "Simpan Dinas"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UploadDinas;
